var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15 13.3137 12.3137 16 9 16C7.81929 16 6.71824 15.659 5.78998 15.07L3 16L3.92999 13.21C3.34104 12.2818 3 11.1807 3 10C3 6.68629 5.68629 4 9 4C12.3137 4 15 6.68629 15 10Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33789 15.9896C10.1586 18.3254 12.3838 20 15.0001 20C16.1808 20 17.2819 19.659 18.2101 19.07L21.0001 20L20.0701 17.21L20.2122 16.9744C20.7136 16.0977 21.0001 15.0823 21.0001 14C21.0001 10.6863 18.3138 8 15.0001 8L14.7752 8.00414L14.6623 8.01014",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.3269141b576876a4eeb468a87a5fe506.svg";
export { ForwardRef as ReactComponent };